export default __webpack_public_path__ + "eacd5637b662e22bb6e38c8164dedb3d.svg";